import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Users, Star, Sparkles } from "lucide-react";

const catLabel = {
  banquet_hall: "Banquet Hall",
  lawn: "Lawn",
  catering: "Catering",
  hotel_banquet: "Hotel Banquet",
  decoration: "Decoration",
};

export default function VenueCard({ v, compact = false, testIdPrefix = "venue" }) {
  return (
    <motion.div initial={{opacity: 0, y: 12}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{duration: 0.5}}>
      <Link to={`/property/${v.id}`} className="block card-luxury overflow-hidden group" data-testid={`${testIdPrefix}-card-${v.id}`}>
        <div className="relative aspect-[4/3] overflow-hidden">
          <img src={v.images?.[0] || "https://images.unsplash.com/photo-1519741497674-611481863552?w=800"} alt={v.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
          {v.highlighted && (
            <span className="absolute top-3 left-3 inline-flex items-center gap-1 text-[10px] uppercase tracking-widest-2 px-2 py-1 rounded-full bg-[color:var(--gold)] text-black">
              <Sparkles className="w-3 h-3"/> Premium
            </span>
          )}
          <span className="absolute top-3 right-3 text-[10px] uppercase tracking-widest-2 px-2 py-1 rounded-full bg-white/90">
            {catLabel[v.category] || v.category}
          </span>
        </div>
        <div className={`p-5 ${compact ? "space-y-1" : "space-y-2"}`}>
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-display text-xl leading-tight text-neutral-900">{v.name}</h3>
            {v.rating > 0 && (
              <span className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-[color:var(--ivory-2)]">
                <Star className="w-3 h-3 fill-[color:var(--gold)] text-[color:var(--gold)]"/> {v.rating}
              </span>
            )}
          </div>
          <div className="flex items-center gap-3 text-xs text-neutral-600">
            <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3"/> {v.city}</span>
            <span className="inline-flex items-center gap-1"><Users className="w-3 h-3"/> {v.pax_min}–{v.pax_max}</span>
          </div>
          {!compact && (
            <div className="pt-2 flex items-center justify-between">
              <div className="text-sm">
                <span className="text-neutral-500 text-xs">from</span>{" "}
                <span className="font-semibold text-[color:var(--wine)]">₹{Number(v.price_per_day||0).toLocaleString("en-IN")}</span>
                <span className="text-xs text-neutral-500">/day</span>
              </div>
              <span className="text-xs text-[color:var(--wine)] group-hover:underline">View details →</span>
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  );
}

export function VenueCardSkeleton() {
  return (
    <div className="card-luxury overflow-hidden">
      <div className="aspect-[4/3] skeleton"/>
      <div className="p-5 space-y-3">
        <div className="h-5 w-3/4 skeleton"/>
        <div className="h-3 w-1/2 skeleton"/>
        <div className="h-3 w-1/3 skeleton"/>
      </div>
    </div>
  );
}
